<template>
	<div class="PurchasedChapters">
		<div class="topPart">
			<span>全部章节</span>
		</div>
		<!-- 搜索 -->
		<div class="searchBox">
			<img src="../assets/img/BookSearch_icon.svg" alt="" @click="SearchFn" />
			<input placeholder="请输入名称" v-model="bookName" @keydown.enter="SearchFn" />
		</div>
		<!-- 搜索结果为空 -->
		<div class="searchBlank" v-if="showBlank">
			<img src="../assets/img/searchBlank_mobile.svg" alt="" />
			<p>没有你要的内容</p>
		</div>
		<!-- 目录 -->
		<ul ref="PurchasedList" v-else>
			<li v-for="(item,index) in list" :key="index">
				<div v-if="item.children == null || item.children.length == 0">
					<!-- 章 or 节 -->
					<div :class="item.pageCount > 0?'nodeWrap canHover':'nodeWrap'">
						<span :title="item.title" :class="item.id == readingPhapterId || item.light?'ReadingNode':item.pageCount > 0?'nodeText':'onlyshow'"
						 @click="Reading(item.pageCount,item.purchased,item.id,item.tryReadingPages,item.currentPrice,1)">{{item.title}}</span>
						<span class="tryRead" v-if="item.tryReadingPages > 0 && !item.purchased" @click="Reading(item.pageCount,item.purchased,item.id,item.tryReadingPages,item.currentPrice,1)"></span>
						<span class="AllRead" v-if="item.purchased && item.pageCount > 0" @click="Reading(item.pageCount,item.purchased,item.id,item.tryReadingPages,item.currentPrice,1)"></span>
						<!-- 加入购物车 -->
						<span class="Addbooklist" v-if="item.currentPrice != -1 && !item.purchased" @click="ChapterBuy('cart',item.id)"></span>
						<!-- 直接购买 -->
						<!-- <span class="Addbooklist" style="display: none;" @click="ChapterBuy('zj',item.id)"></span> -->
					</div>
				</div>
				<div v-else>
					<!-- 章 -->
					<div class="chapterWrap">
						<span>{{item.title}}</span>
					</div>
					<!-- 节 -->
					<div v-for="(it,ind) in item.children" :key="ind" :class="it.pageCount > 0?'nodeWrap canHover':'nodeWrap'">
						<span :title="it.title" :class="it.id == readingPhapterId || it.light?'ReadingNode':it.pageCount > 0?'nodeText':'onlyshow'" @click="Reading(it.pageCount,it.purchased,it.id,it.tryReadingPages,it.currentPrice,0,index)">{{it.title}}</span>
						<span class="tryRead" v-if="it.tryReadingPages > 0 && !it.purchased" @click="Reading(it.pageCount,it.purchased,it.id,it.tryReadingPages,it.currentPrice,0,index)"></span>
						<span class="AllRead" v-if="it.purchased && it.pageCount > 0" @click="Reading(it.pageCount,it.purchased,it.id,it.tryReadingPages,it.currentPrice,0,index)"></span>
						<!-- 加入购物车 -->
						<span class="Addbooklist" v-if="it.currentPrice != -1 && !it.purchased && item.subChapterCount > 1" @click="ChapterBuy('cart',it.id)"></span>
						<!-- 直接购买 -->
						<!-- <span class="Addbooklist" style="display: none;" @click="ChapterBuy('zj',it.id)"></span> -->
					</div>
				</div>
			</li>
		</ul>
		<!-- 付款 -->
		<div class="PopupWrap" v-if="showBuy">
			<DownloadChapter :downloadWay="downloadWay" :chapterId="BuyId" :goods="Goods" :sellWayText="textTip" />
		</div>
		<!-- 试读 -->
		<div v-if="showTryRead">
			<TryRead :fatherId="fatherid" :tryReadId="tryReadId" :firstChildId="firstchildId" :InformationId="InformationId" :sellWay="sellway" />
		</div>
		<!-- 加入购物车成功提示 -->
		<div v-if="showAddCartTip">
			<addCartSuccess :bookImgUrl="addCartInfo.imagePath" :bookTitle="addCartInfo.name" :chapterTitle="addCartInfo.informationTitle" />
		</div>
	</div>
</template>

<script>
	import common from '../assets/js/common.js'
	import DownloadChapter from './DownloadChapter.vue'
	import TryRead from './TryRead.vue'
	import addCartSuccess from './addCartSuccess.vue'
	export default {
		data() {
			return {
				bookName: '', // 输入框值
				showBlank: false, // 是否显示空白页
				BuyId: undefined, // 商品节的id
				showBuy: false, // 是否显示付款界面
				Goods: {}, // 商品
				downloadWay: 0, // 支付购买方式
				isdevice: true, // 判断设备 true:pc false:mobile
				list: [], // 渲染
				showTryRead: false, // 试读
				tryReadId: undefined, // 当前试读id
				fatherid: undefined, // 当前试读的章id
				firstchildId: undefined, // 当前试读章的第一个节id
				sellway: undefined, // 购买方式(节可能可以试读，但不能单独)
				textTip: undefined, // 试读里售卖方式
				margintop: 0, // 滚轮距离
				showAddCartTip: false,  // 加入购物车成功提示
				addCartInfo: {}
			}
		},
		props: {
			// 正在读的节
			readingPhapterId: {
				type: Number,
				default: undefined
			},
			// 情报列表
			catalogList: {
				type: Array,
				default: function() {
					return []
				}
			},
			// 情报id
			InformationId: {
				type: Number,
				default: undefined
			},
		},
		mounted() {
			// 搜索后是否显示空白页
			common.$on('IsShowBlank', (params) => {
				this.showBlank = params;
			});
			// 触发关闭章节购买事件车
			common.$on('closeChapter', () => {
				this.showBuy = false;
			});
			// 赋值 渲染
			this.list = this.catalogList;
			// 判断加载哪个dom
			let wid = window.innerWidth;
			if (wid >= 320 && wid <= 1024) {
				this.isdevice = false;
			} else {
				// 滚轮位置  allIndex 当前章or节index
				common.$on('ScrollTopVal', (count, allIndex) => {
					let hei = this.$refs.PurchasedList.offsetHeight;
					let sHei = this.$refs.PurchasedList.scrollHeight;
					let moreNum = Math.floor(hei / 40); // 可放的节数
					let num = allIndex - moreNum;
					let top = 0;
					if (num >= -2) {
						top = allIndex >= count - moreNum / 2 ? sHei : Math.ceil(allIndex * 40 / 2);
						this.margintop = top;
						this.$refs.PurchasedList.scrollTop = top;
					} else {
						this.$refs.PurchasedList.scrollTop = 0;
					}
				});
				setTimeout(() => {
					this.$refs.PurchasedList.scrollTop = this.margintop;
				}, 800);
			}
			// 关闭试读
			common.$on('closeRead', () => {
				this.showTryRead = false;
			});
			// 购买
			this.BuyBookWay();
			// 关闭加入购物车成功提示
			common.$on('closeTip', ()=> {
				this.showAddCartTip = false
				console.log('purchase CLOSETIP')
			})
		},
		methods: {
			// 打开章节购买-获取情报里的内容商品  chapterId:为整章下载的第一节id isgoods:是否是商品 isCart: 值为cart 购物车方式
			ChapterBuy(isCart, id) {
				this.$fetch('/Login')
					.then((res) => {
						// 判断登陆状态
						if (res.data.accessAllowed === false) {
							this.LoginTipFn();
							return;
						}
						// pc
						if (this.isdevice) {
							this.PcPayment(isCart,id);
							return;
						}
						// 移动端
						this.MobilePayment(isCart,id);
					}).catch((err) => {
						throw err;
					});
			},
			// 支付方式
			BuyBookWay() {
				common.$on('buyBook', (isCart, type, issell, chapterId, firstchildId) => {
					// *直接购买方式isCart: zj
					this.textTip = issell;
					// 加入购物车方式isCart: cart
					if(issell === -1) {
						this.$confirm('您选择试读的文章无法单独加入书单，所以将选择其所在章（书）加入，是否继续？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							if (type == 0) {
								this.GetSingleGoods(isCart,chapterId, firstchildId);
							} else if (type == 1) {
								this.GetGoods(isCart);
							}
						}).catch(() => {});
					}else {
						if (type == 0) {
							this.GetSingleGoods(isCart, chapterId, firstchildId);
						} else if (type == 1) {
							this.GetGoods(isCart);
						}
					}
				});
			},
			// 获取单个商品
			GetSingleGoods(isCart, id, chapterId) {
				this.downloadWay = 0;
				this.BuyId = chapterId ? chapterId : id;
				this.$fetch('/api/information/' + this.InformationId + '/informationContent/goods/?id=' + id)
					.then((res) => {
						if(isCart === 'cart') {
							// 商品信息
							this.addCartInfo = res.data
							// 加入购物车
							this.addToCartFn(res.data.id)
							return
						}
						
						// *直接购买方式-打开购买弹窗（暂时弃用）
						this.Goods = res.data;
						this.showBuy = true;
					}).catch((err) => {
						throw err;
					});
			},
			// 获取整个情报商品
			GetGoods(isCart) {
				this.downloadWay = 1;
				this.BuyId = sessionStorage.getItem('firstPurchasedId');
				this.$fetch('/api/information/goods/?id=' + this.InformationId)
					.then((res) => {
						if(isCart === 'cart') {
							// 商品信息
							this.addCartInfo = res.data
							// 加入购物车
							this.addToCartFn(res.data.id)
							return
						}
						
						// *直接购买方式-打开购买弹窗（暂时弃用）
						this.Goods = res.data;
						this.showBuy = true;
					}).catch((err) => {
						throw err;
					});
			},
			// 去支付--mobile
			MobilePayment(isCart,id) {
				// 加入购物车方式 获取商品id
				if(isCart === 'cart') {
					this.GetSingleGoods('cart', id);
					return
				}
				
				// *直接购买方式-打开购买弹窗（暂时弃用）
				this.$router.push({
					name: "BookPayment",
					query: {
						type: 0,
						InformationId: this.InformationId,
						id: id,
						chapterId: id
					}
				});
			},
			// pc端支付操作
			PcPayment(isCart,id) {
				// 获取商品信息
				this.BuyId = id;
				this.$fetch('/api/information/' + this.InformationId + '/informationContent/goods/?id=' + id)
					.then((res) => {
						if(isCart === 'cart') {
							// 商品信息
							this.addCartInfo = res.data
							// 加入购物车
							this.addToCartFn(res.data.id)
							return
						}
						
						// *直接购买-打开购买弹窗（暂时舍弃）
						this.Goods = res.data;
						this.showBuy = true;
					}).catch((err) => {
						throw err;
					});
			},
			// 加入购物车
			addToCartFn(goodsId) {
				this.$post('/api/ShoppingCarts', {'goodsId': goodsId}).then(res => {
					// 获取购物车数量
					this.getCartCountFn();
					// 提示
					this.showAddCartTip = true
				}).catch(err => {
					this.$message({
						message: err.response.data,
						type: 'error',
						offset: 100
					});
				})
			},
			// 获取购物车数量
			getCartCountFn() {
				common.$emit('getCartNum')
			},
			// 判断是否登录
			LoginTipFn() {
				this.$confirm('此操作需登录后进行，是否继续？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let nowHref = location.href;
					let href = 'https://www.tunnelling.cn/PMember/MemberLogin.aspx?returnUrl=' + encodeURIComponent(nowHref);
					location.href = href;
				}).catch(() => {});
			},
			// 阅读
			Reading(pagecount, ispurchased, id, tryReadPage, currentPrice, layout, index) {
				if (pagecount === 0) return;
				if (ispurchased) {
					if (layout === 0) index = undefined;
					common.$emit('ReadPuchased', id, index);
					return;
				}
				if (tryReadPage === 0) return;
				let type = 0;
				type = layout;
				if (this.isdevice) {
					this.showTryRead = true;
					this.tryReadId = id;
					this.sellway = type;
					if (type == 0) {
						let arr = this.catalogList[index];
						this.fatherid = arr.id;
						this.firstchildId = arr.children[0].id;
					}
				} else {
					if (type == 1) {
						this.$router.push({
							path: '/bookTryRead',
							query: {
								id: id,
								InformationId: this.InformationId,
								sellway: type
							},
						});
						return;
					}
					let arr = this.catalogList[index];
					this.$router.push({
						path: '/bookTryRead',
						query: {
							id: id,
							fatherId: arr.id,
							firstchildId: arr.children[0].id,
							InformationId: this.InformationId,
							sellway: type
						}
					});
				}
			},
			// 搜索
			SearchFn() {
				common.$emit('SearchPuchased', this.bookName);
			}
		},
		components: {
			DownloadChapter,
			TryRead,
			addCartSuccess
		},
		watch: {
			catalogList: {
				handler(newValue) {
					this.list = this.catalogList;
				},
				deep: true,
				immediate: true
			}
		}
	}
</script>

<style scoped>
	@media screen and (min-width: 320px) and (max-width: 1024px) {
		.PurchasedChapters {
			width: 100%;
			height: 9rem;
			padding: 0 .25rem;
			background: #353535;
			overflow: hidden;
			position: absolute;
			bottom: 0;
			right: 0;
			display: flex;
			flex-direction: column;
		}

		/* 已购章节+全部目录 */
		.topPart {
			display: flex;
			justify-content: space-between;
			align-items: center;
			height: .9rem;
		}

		.topPart span {
			display: block;
		}

		.topPart span:first-child {
			font-size: .28rem;
			color: rgba(255, 255, 255, 0.80);
			letter-spacing: 0;
		}

		/* 搜索 */
		.searchBox {
			display: flex;
			align-items: center;
			background: #2B2B2B;
			border-radius: .08rem;
			width: 100%;
			height: .6rem;
			margin: .14rem 0 .17rem;
		}

		.searchBox img {
			margin: 0 .24rem 0 .16rem;
		}

		.searchBox input {
			width: 80%;
			background: #2B2B2B;
			font-size: .24rem;
			color: #979797;
			letter-spacing: 0;
		}

		/* 目录 */
		.PurchasedChapters ul {
			width: 100%;
			flex: 1;
			overflow: hidden;
			overflow-y: scroll;
		}

		.chapterWrap,
		.nodeWrap {
			padding: 0 .1rem;
		}

		/* 章 */
		.chapterWrap span {
			font-size: .24rem;
			color: rgba(255, 255, 255, 0.90);
			display: block;
			width: calc(100% - .7rem);
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			padding: .1rem 0;
		}

		.chapterWrap span::before {
			width: 4px;
			height: 14px;
			display: inline-block;
			background: #2468F2;
			margin-right: 10px;
			content: ' ';
			vertical-align: middle;
		}

		/* 节 */
		.nodeWrap {
			display: flex;
			justify-content: space-between;
			align-items: center;
		}

		.nodeWrap span {
			font-size: .24rem;
			letter-spacing: 0.6px;
		}

		.nodeWrap span:first-child {
			color: rgba(255, 255, 255, 0.90);
			text-indent: 14px;
			width: calc(100% - .7rem);
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			padding: .1rem 0;
		}

		.nodeWrap span:last-child {
			color: rgba(255, 255, 255, 0.20);
		}

		.onlyshow {
			font-size: .2rem;
			padding-left: .2rem !important;
			color: rgba(255, 255, 255, 0.60) !important;
		}

		/* 搜索-空白页 */
		.searchBlank {
			width: 100%;
			height: 390px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
		}

		.searchBlank p {
			font-size: .24rem;
			color: rgba(255, 255, 255, 0.50);
			margin-top: .27rem;
		}

		.tryRead,
		.Addbooklist,
		.AllRead {
			display: block;
			width: .44rem;
			height: .44rem;
		}

		.tryRead {
			background: url(../assets/img/try_icon.svg) no-repeat;
			background-size: 100% 100%;
			margin-right: 3px;
		}

		.Addbooklist {
			background: url(../assets/img/allChapter_mobile.svg) no-repeat;
			background-size: 100% 100%;
		}

		.AllRead {
			background: url(../assets/img/Purchased_mobile.svg) no-repeat;
			background-size: 100% 100%;
		}
	}

	@media screen and (min-width: 1442px) {
		.PurchasedChapters {
			width: 400px;
			height: 100%;
			background: #353535;
			overflow: hidden;
		}

		/* 已购章节+全部目录 */
		.PurchasedChapters .topPart {
			display: none;
		}

		/* 搜索 */
		.searchBox {
			display: flex;
			align-items: center;
			background: #2B2B2B;
			border-radius: 8px;
			width: 380px;
			height: 40px;
			margin: 0 10px;
		}

		.searchBox img {
			margin: 0 12px 0 22px;
		}

		.searchBox input {
			width: 80%;
			background: #2B2B2B;
			font-size: 14px;
			color: #979797;
			letter-spacing: 0;
			line-height: 14px;
		}

		/* 目录 */
		.PurchasedChapters ul {
			width: 100%;
			height: calc(100% - 60px);
			margin: 12px 0;
			overflow: hidden;
			overflow-y: scroll;
		}

		.PurchasedChapters .canHover:hover {
			background: #2B2B2B;
		}

		.canHover {
			cursor: pointer !important;
		}

		.chapterWrap,
		.nodeWrap {
			padding: 0 10px;
		}

		/* 章 */
		.chapterWrap span {
			font-size: 14px;
			color: rgba(255, 255, 255, 0.90);
			letter-spacing: 0;
			line-height: 14px;
			display: block;
			width: calc(100% - 35px);
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			padding: 10px 0;
		}

		.chapterWrap span::before {
			width: 4px;
			height: 14px;
			display: inline-block;
			background: #2468F2;
			margin-right: 10px;
			content: ' ';
			vertical-align: middle;
		}

		/* 节 */
		.nodeWrap {
			display: flex;
			justify-content: space-between;
			align-items: center;
			cursor: default;
		}

		.nodeWrap span {
			font-size: 14px;
			letter-spacing: 0.6px;
		}

		.nodeWrap span:first-child {
			color: rgba(255, 255, 255, 0.90);
			text-indent: 14px;
			width: 300px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			padding: 10px 0;
		}

		.nodeWrap span:last-child {
			color: rgba(255, 255, 255, 0.20);
		}

		.onlyshow {
			padding-left: 15px !important;
			font-size: 12px;
			color: rgba(255, 255, 255, 0.60) !important;
		}

		/* 搜索-空白页 */
		.searchBlank {
			width: 100%;
			height: 390px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
		}

		.searchBlank p {
			font-size: 24px;
			color: rgba(255, 255, 255, 0.50);
			margin-top: 27px;
		}

		.tryRead,
		.Addbooklist,
		.AllRead {
			display: block;
			width: 26px;
			height: 26px;
			cursor: pointer;
		}

		.tryRead {
			background: url(../assets/img/try_icon.svg) no-repeat;
			background-size: 100% 100%;
			margin-right: 3px;
		}

		.Addbooklist {
			background: url(../assets/img/allChapter_mobile.svg) no-repeat;
			background-size: 100% 100%;
		}

		.AllRead {
			background: url(../assets/img/Purchased_mobile.svg) no-repeat;
			background-size: 100% 100%;
		}
	}

	@media screen and (min-width: 1029px) and (max-width: 1440px) {
		.PurchasedChapters {
			width: 310px;
			height: 100%;
			background: #353535;
			overflow: hidden;
		}

		/* 已购章节+全部目录 */
		.PurchasedChapters .topPart {
			display: none;
		}

		/* 搜索 */
		.searchBox {
			display: flex;
			align-items: center;
			background: #2B2B2B;
			border-radius: 8px;
			width: 290px;
			height: 40px;
			margin: 0 10px;
		}

		.searchBox img {
			margin: 0 12px 0 22px;
		}

		.searchBox input {
			width: 80%;
			background: #2B2B2B;
			font-size: 14px;
			color: #979797;
			letter-spacing: 0;
			line-height: 14px;
		}

		/* 目录 */
		.PurchasedChapters ul {
			width: 100%;
			height: calc(100% - 50px);
			margin: 10px 0;
			overflow: hidden;
			overflow-y: scroll;
		}

		.PurchasedChapters .canHover:hover {
			background: #2B2B2B;
		}

		.canHover {
			cursor: pointer !important;
		}

		.chapterWrap,
		.nodeWrap {
			padding: 0 6px;
		}

		/* 章 */
		.chapterWrap span {
			font-size: 14px;
			color: rgba(255, 255, 255, 0.90);
			letter-spacing: 0;
			line-height: 14px;
			display: block;
			width: calc(100% - 20px);
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			padding: 6px 0;
		}

		.chapterWrap span::before {
			width: 4px;
			height: 14px;
			display: inline-block;
			background: #2468F2;
			margin-right: 10px;
			content: ' ';
			vertical-align: middle;
		}

		/* 节 */
		.nodeWrap {
			display: flex;
			justify-content: space-between;
			align-items: center;
			cursor: default;
		}

		.nodeWrap span {
			font-size: 13px;
		}

		.nodeWrap span:first-child {
			color: rgba(255, 255, 255, 0.90);
			text-indent: 10px;
			width: calc(100% - 65px);
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			padding: 6px 0;
		}

		.nodeWrap span:last-child {
			color: rgba(255, 255, 255, 0.20);
		}

		.onlyshow {
			padding-left: 12px !important;
			font-size: 12px;
			color: rgba(255, 255, 255, 0.60) !important;
		}

		/* 搜索-空白页 */
		.searchBlank {
			width: 100%;
			height: 390px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
		}

		.searchBlank p {
			font-size: 24px;
			color: rgba(255, 255, 255, 0.50);
			margin-top: 27px;
		}

		.tryRead,
		.Addbooklist,
		.AllRead {
			display: block;
			width: 20px;
			height: 20px;
			cursor: pointer;
		}

		.tryRead {
			background: url(../assets/img/try_icon.svg) no-repeat;
			background-size: 100% 100%;
			margin-right: 5px;
		}

		.Addbooklist {
			background: url(../assets/img/allChapter_mobile.svg) no-repeat;
			background-size: 100% 100%;
		}

		.AllRead {
			background: url(../assets/img/Purchased_mobile.svg) no-repeat;
			background-size: 100% 100%;
		}
	}

	/* 正在读 */
	.PurchasedChapters .nodeWrap .ReadingNode {
		color: #FF7B5B;
	}

	.PurchasedChapters .nodeWrap .nodeText {
		color: rgba(255, 255, 255, 0.90);
	}
</style>



// WEBPACK FOOTER //
// src/components/PurchasedChapters.vue